import React from 'react';
import { LazySuspense, lazy } from 'react-loosely-lazy';
import { useShouldShowJiraLockScreen } from '../../services/should-show-jira-lock-screen';
import type { LockScreenModalProps } from './types';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyLockScreenModal = lazy(() =>
	import(/* webpackChunkName: "lock-screen-modal" */ './main').then(
		(module) => module.LockScreenModalComponent,
	),
);

export const AsyncLockScreenModal = (props: LockScreenModalProps) => {
	const shouldShowJiraLockScreen = useShouldShowJiraLockScreen({
		predunningDaysLeft: props.predunningDaysLeft,
	});

	if (!shouldShowJiraLockScreen) {
		return null;
	}

	return (
		<LazySuspense fallback={null}>
			<LazyLockScreenModal {...props} />;
		</LazySuspense>
	);
};
